import { ALL_COMPANY_DOMAINS } from "src/common/utils/lastActiveContext.js";
import { useLastActiveContext } from "src/common/utils/hooks/useLastActiveContext.js";
import { useLoadedCompanyDomains } from "src/routes/routeDataHooks.js";
import { AllDomainsSidebarPart } from "./AllDomainsSidebarPart.js";
import { Sidebar } from "./Sidebar.js";

/** Sidebar at bare `/`: empty by default, full chrome when "All domains" is active. */
export const HomeSidebar = () => {
	const companyDomains = useLoadedCompanyDomains();
	// Reactive, like Home.tsx's own read — see the WHY there.
	const { value: lastActiveContext } = useLastActiveContext();
	const isAllDomains =
		lastActiveContext?.companyDomainId === ALL_COMPANY_DOMAINS;

	if (companyDomains.length === 0 || !isAllDomains) {
		return <Sidebar empty />;
	}

	return (
		<Sidebar
			renderContent={({ sidebarOpen }) => (
				<AllDomainsSidebarPart sidebarOpen={sidebarOpen} />
			)}
		/>
	);
};
